import React from 'react';

import { CrewSchedule, CrewDayPlan } from '../../../shared/types/crewSchedule';
import { CrewDaySchedule, CrewDayProgram } from '.';
import { getCrewSchedules, getCrewDayPlans } from '../../lib/api/crewSchedule';
import { CrewNotifications } from './CrewNotifications/CrewNotifications';
import { clearUserToken } from '@go-client/lib/auth';
import { EmptyTab } from '../EmptyTab/EmptyTab';
import { TextButton, TabPanel, TabContent } from '@spark-labs/avocado-ui';

export interface ScheduleProps {
  staffTemplateId: string;
  date: Date;
  staffId: string;
  history: any;
}

export interface ScheduleState {
  crewSchedules: CrewSchedule[];
  dayPlans: CrewDayPlan[];
  selectedTab: number;
}

export default class Schedule extends React.Component<ScheduleProps, ScheduleState> {
  public readonly state: ScheduleState = { selectedTab: 0, crewSchedules: [], dayPlans: [] };

  constructor(props: ScheduleProps) {
    super(props);

    this.handleTabChange = this.handleTabChange.bind(this);
  }

  public componentDidMount() {
    return this.loadSchedules(this.props.staffTemplateId, this.props.date);
  }

  public componentDidUpdate(prevProps: ScheduleProps) {
    if (prevProps.date !== this.props.date) {
      return this.loadSchedules(this.props.staffTemplateId, this.props.date);
    }
  }

  public render() {
    return (
      <div className="flex flex-col flex-grow overflow-y-hidden">
        <div className="inline-flex items-center px-2 py-1 bg-blue-darkest crew-header">
          <h3 className="italic text-white">Crew App</h3>
          <CrewNotifications staffRoleId={this.props.staffId} />
          <TextButton className="text-blue-light mr-3" onClick={() => this.logout()}>
            Logout
          </TextButton>
        </div>

        <TabPanel
          className="flex flex-col overflow-y-hidden"
          selectedTab={this.state.selectedTab}
          onTabChange={this.handleTabChange}
        >
          <TabContent title="Your Schedule" className="border-t overflow-y-auto">
            {this.state.crewSchedules.length !== 0 ? (
              this.state.crewSchedules.map((schedule, i) => (
                <CrewDaySchedule key={i} schedule={schedule} />
              ))
            ) : (
              <EmptyTab message={"You don't have anything scheduled yet"} />
            )}
          </TabContent>
          <TabContent title="Daily Program" className="border-t overflow-y-auto">
            {this.state.dayPlans.length !== 0 ? (
              this.state.dayPlans.map((dayPlan, i) => <CrewDayProgram key={i} plan={dayPlan} />)
            ) : (
              <EmptyTab message={"You don't have anything scheduled yet"} />
            )}
          </TabContent>
        </TabPanel>
      </div>
    );
  }

  private logout = () => {
    clearUserToken();
    setTimeout(() => this.props.history.push('/crew'), 100);
  };

  private handleTabChange(newTab: number) {
    this.setState({ selectedTab: newTab });
  }

  private async loadSchedules(staffTemplateId: string, date: Date) {
    let [crewSchedules, dayPlans] = await Promise.all([
      getCrewSchedules(staffTemplateId, date),
      getCrewDayPlans(staffTemplateId, date),
    ]);
    this.setState({ crewSchedules, dayPlans });
  }
}
